export default __webpack_public_path__ + "static/media/footer bg.5cca1a23.png";